module.exports = __webpack_public_path__ + "assets/images/storehouse.32d15e58d7416d554eab56d11759a4ad.png";